enum AccessEventEnum {
	AccessDenied = 'accessDenied',
	CardNotFound = 'accessDeniedCardNotFound',
	HashMissMatch = 'accessDeniedCardHashMissMatch',
	NoRuleFound = 'accessDeniedNoRuleFound',
	NoReservationFound = 'accessDeniedNoReservationFound',
	GrantedRule = 'accessGrantedRule',
	GrantedReservation = 'accessGrantedReservation',
	Error = 'error',
}

export default AccessEventEnum;
